import { Button, Modal } from '@/components/ui/daisy';
import { ValidationErrorProps } from './ValidationErrorHandler';
import { LessonNotPublishedError } from '../useContPedStatus';
import { useTranslation } from 'react-i18next';
import { useModalDialog } from '@/components/ui/daisy/modal/hooks';

export default function LessonNotPublishedFeedback({
  error,
  onClose,
}: ValidationErrorProps<LessonNotPublishedError>) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.courseWorkspace.validation.noPublishedLessons',
  });
  const { ref, close } = useModalDialog(error, onClose);
  return (
    <Modal ref={ref}>
      <Modal.Box>
        <Modal.Close onClick={close} />
        <h3 className="text-lg font-bold text-error">{t('title')}</h3>
        <p className="py-4">{t('description')}</p>
        <Modal.Action>
          <Button onClick={close}>{t('close')}</Button>
        </Modal.Action>
      </Modal.Box>
      <Modal.Backdrop />
    </Modal>
  );
}
